module.exports = __webpack_public_path__ + "img/fragment_100.4ae9525b.png";